
document.addEventListener('DOMContentLoaded', () => {
    const applyMouseHoverMenu = () => {
    const headerWrapper = document.querySelector('.header-wrapper');
    const mainDropMenuSetting = headerWrapper ? headerWrapper.dataset.maindrop : 'click';

    if (mainDropMenuSetting === 'mousehover') {
        let currentlyOpenMenu = null; // To keep track of the currently open menu
        let currentlyChildOpenMenu = null; // To keep track of the currently child open menu
        

        const expandMenu = (event) => {
        const summary = event.currentTarget;
        const parentElement = summary.parentElement;

        if (summary) {
            summary.setAttribute('aria-expanded', true);
        }
        parentElement.setAttribute('open', 'true');
        if (currentlyChildOpenMenu && currentlyChildOpenMenu !== parentElement && parentElement.dataset.isChild) {
            const previousSummary = currentlyChildOpenMenu.querySelector('summary');
            if (previousSummary) {
            previousSummary.setAttribute('aria-expanded', false);
            }
            currentlyChildOpenMenu.removeAttribute('open');
            currentlyChildOpenMenu = parentElement;
            return;
        } else if(parentElement.dataset.isChild){
            currentlyChildOpenMenu = parentElement;
            return;
        }

        if (currentlyOpenMenu && currentlyOpenMenu !== parentElement) {
            const previousSummary = currentlyOpenMenu.querySelector('summary');
            if (previousSummary) {
            previousSummary.setAttribute('aria-expanded', false);
            }
            currentlyOpenMenu.removeAttribute('open');
        }

        
        currentlyOpenMenu = parentElement;
        };

        const collapseMenu = (event) => {
        const parentElement = event.currentTarget;
        const summary = parentElement.querySelector('summary');

        setTimeout(() => {
            if (!parentElement.matches(':hover') && !parentElement.querySelector('.mega-menu__content:hover')) {
            if (summary) {
                summary.setAttribute('aria-expanded', false);
            }
            parentElement.removeAttribute('open');
            if (currentlyOpenMenu === parentElement) {
                currentlyOpenMenu = null;
            }
            }
        }, 200);
        };

        document.querySelectorAll('[id^="Details-"]').forEach(parentElement => {
        if (parentElement) {
            const summary = parentElement.querySelector('summary');
            const megaMenuContent = parentElement.querySelector('.mega-menu__content');

            if (summary) {
            summary.addEventListener('mouseenter', expandMenu);
            summary.addEventListener('mouseleave', collapseMenu);
            }

            if (megaMenuContent) {
            megaMenuContent.addEventListener('mouseenter', expandMenu);
            megaMenuContent.addEventListener('mouseleave', collapseMenu);
            }

            // Add event listener to parent element
            if (parentElement) {
            parentElement.addEventListener('mouseleave', collapseMenu);
            }
        }
        });
    }
    };

    // Apply mouse hover menu based on screen size
    const mediaQuery = window.matchMedia('(min-width: 992px)');
    const handleMediaQueryChange = (e) => {
    if (e.matches) {
        applyMouseHoverMenu();
    }
    };
    handleMediaQueryChange(mediaQuery);
    mediaQuery.addEventListener('change', handleMediaQueryChange);
});

// document.addEventListener('DOMContentLoaded', () => {
//   const banner = document.querySelector('.imagebannermain');
//   const yotpoSection = document.querySelector('.shopify-section:has(#yopto-link-wrapper)');

//   window.addEventListener('scroll', () => {
//     const bannerRect = banner.getBoundingClientRect();
//     const scrolledPast = -bannerRect.top;
//     const halfBanner = banner.offsetHeight / 2;

//     if (scrolledPast >= halfBanner) {
//       yotpoSection.classList.add('slide-up');
//     } else {
//       yotpoSection.classList.remove('slide-up');
//     }
//   });
// });
// if (window.innerWidth >= 767) {
// window.addEventListener('scroll', function () {

//     const banner = document.querySelector('.section-image-banner');
//     const target = document.querySelector('#yopto-link-wrapper');

//     if (!banner || !target) return;

//     const rect = banner.getBoundingClientRect();

//     // start after 50% banner visible
//     let move = (window.innerHeight - rect.top - (rect.height * 0.9)) * 0.2;

//     // limit move
//     move = Math.max(0, Math.min(move, 100));

//     // transform move
//     target.style.transform = `translateY(-${move}px)`;

// });
// }

/* Site-audit fix: Cloudflare email-protection hrefs (e.g. Yotpo review titles) are crawlable 404s.
   Unwrap to plain text, or point to customer support if no readable email text. */
(function () {
  function fixCfEmailLinks(root) {
    var links = (root || document).querySelectorAll('a.__cf_email__[href*="email-protection"], a[href="/cdn-cgi/l/email-protection"], a[href*="/cdn-cgi/l/email-protection"]');
    links.forEach(function (a) {
      var text = (a.textContent || '').trim();
      var span = document.createElement('span');
      span.className = a.className;
      if (a.getAttribute('data-cfemail')) span.setAttribute('data-cfemail', a.getAttribute('data-cfemail'));
      if (text && text.toLowerCase().indexOf('email') === -1) {
        span.textContent = text;
      } else if (text) {
        span.textContent = text.replace(/\u00a0/g, ' ');
      } else {
        var support = document.createElement('a');
        support.href = '/pages/customer-support';
        support.textContent = 'Contact support';
        a.replaceWith(support);
        return;
      }
      a.replaceWith(span);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { fixCfEmailLinks(document); });
  } else {
    fixCfEmailLinks(document);
  }
  // Yotpo may inject later
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () { fixCfEmailLinks(document); }, 1500);
    setTimeout(function () { fixCfEmailLinks(document); }, 4000);
  });
})();
